import { RecordOf } from '@opengov/compose-app/immutable';
export var SavedView = RecordOf({
  id: null,
  description: null,
  title: null,
  reportId: null,
  reportConfiguration: null,
  entityId: null,
  previewEmbedId: null,
  createdAt: null
});